const IS_DEV_BUILD = import.meta.env.DEV || import.meta.env.VITE_ENV === 'DEV';

export function isPopupDebugEnabled(): boolean {
  if (!IS_DEV_BUILD) return false;
  try {
    const w = window as any;
    if (typeof w.__HS_POPUP_DEBUG === 'boolean') {
      return w.__HS_POPUP_DEBUG;
    }
    // Default OFF. Verbose logging is opt-in per page load via `setPopUpBlockerDebug(true)`.
    return false;
  } catch {
    return false;
  }
}

export function setPopupDebugEnabled(enabled: boolean): boolean {
  if (!IS_DEV_BUILD) return false;
  const next = Boolean(enabled);
  try {
    (window as any).__HS_POPUP_DEBUG = next;
  } catch {
    // ignore
  }
  return next;
}
